import { catalogCategoriesQuery } from "@/gql/catalog-categories.queries";
import { withVirtualNavigationCategories } from "@/utils/catalogNavigationCategories";

function buildNavigationCategories(dataRows) {
  const mapped = dataRows.map((category) => ({
    id: category.id,
    description: category.name,
    parent: category.parent,
    parentId: category.parentId,
    forNotice: category.forNotice,
    isActive: category.isActive,
    children: dataRows.filter((c) => c.parent?.id === category.id).map((c) => c.id),
  }));

  return withVirtualNavigationCategories(mapped);
}

export default {
  namespaced: true,

  state: {
    catalogCategoryRecords: [],
    navigationCategories: [],
    loadedNewCatalog: false,
  },

  getters: {
    getCatalogCategoryRecords(state) {
      return state.catalogCategoryRecords;
    },
    getNavigationCategories(state) {
      return state.navigationCategories;
    },
    getForNoticeCatalogCategoryOptions(state) {
      return state.navigationCategories
        .filter((category) => category.forNotice)
        .map((category) => ({
          id: category.id,
          label: category.description,
        }));
    },
    isNewCatalogCategoriesLoaded(state) {
      return state.loadedNewCatalog;
    },
  },

  mutations: {
    SET_NEW_CATALOG_CATEGORIES(state, { records, navigation }) {
      state.catalogCategoryRecords = records || [];
      state.navigationCategories = navigation || [];
      state.loadedNewCatalog = true;
    },
    CLEAR_NEW_CATALOG_CATEGORIES(state) {
      state.catalogCategoryRecords = [];
      state.navigationCategories = [];
      state.loadedNewCatalog = false;
    },
  },

  actions: {
    async fetchNewCatalogCategories(
      { commit, state },
      { force = true, withLoader = true, filters = {} } = {}
    ) {
      if (state.loadedNewCatalog && !force) {
        return;
      }

      try {
        if (withLoader) {
          commit("loaderTop/SET_LOADING_ON", undefined, { root: true });
        }

        const { default: apolloClient } = await import("@/plugins/apollo-vue");
        const response = await apolloClient
          .query({
            query: catalogCategoriesQuery,
            variables: { filters: { isActive: true, forSidebar: true, ...filters } },
            fetchPolicy: force ? "network-only" : "cache-first",
          })
          .catch(() => null);

        if (!response?.data?.catalogCategories) {
          return;
        }

        const records = response.data.catalogCategories.data;

        commit("SET_NEW_CATALOG_CATEGORIES", {
          records,
          navigation: buildNavigationCategories(records),
        });
      } finally {
        if (withLoader) {
          commit("loaderTop/SET_LOADING_OFF", undefined, { root: true });
        }
      }
    },

    invalidateNewCatalogCategories({ commit }) {
      commit("CLEAR_NEW_CATALOG_CATEGORIES");
    },

    async refreshCatalogCategories({ dispatch }, { withLoader = false } = {}) {
      await dispatch("fetchNewCatalogCategories", { withLoader });
    },
  },
};
